module.exports = __webpack_public_path__ + "img/InnoDesignTech_2016.552c6a74.jpg";